// How many businesses an account may own (docs/plans/business-limit.md): one
// without a paid plan, two with one, or the number an admin gave it. The server
// decides (create_tenant); this only lets the switcher say so before the form opens.
import { tenantApi, type BusinessLimit } from '@ims/remote'
import { useEffect, useState } from 'react'
import { useSession } from '../session.tsx'

/** Why "Create a new business" is closed, or null when the account has room. */
export function noRoomHint(room: BusinessLimit | null): string | null {
  if (!room || room.owned < room.limit) return null
  return room.more_with_plan ? 'Needs a paid plan' : 'Limit reached'
}

/**
 * The account's room, asked again when it comes online or owns a different
 * number of businesses. Null until the server has answered: then the item stays
 * open and create_tenant gives the answer.
 */
export function useBusinessLimit(owned: number, online: boolean): BusinessLimit | null {
  const { platform } = useSession()
  const [room, setRoom] = useState<BusinessLimit | null>(null)
  useEffect(() => {
    if (!online) return
    let active = true
    tenantApi(platform.supabase)
      .businessLimit()
      .then(
        (answer) => active && setRoom(answer),
        () => undefined,
      )
    return () => {
      active = false
    }
  }, [platform, owned, online])
  return room
}
